import { Challenge } from '../models';
import { ChallengeRepository } from '../repositories';
import { logger } from '@/src/core/utils';
import { ModerateContentUseCase } from './ModerateContentUseCase';

export class SendChallengeUseCase {
  constructor(
    private challengeRepository: ChallengeRepository,
    private moderateContent: ModerateContentUseCase,
  ) {}

  async execute(challengerId: string, challengedId: string, message?: string): Promise<Challenge> {
    logger.debug('SendChallenge', 'Sending challenge', { challengerId, challengedId });

    // Moderate message content before writing
    if (message) {
      await this.moderateContent.execute(message, 'challenge_message', challengerId);
    }

    const challenge = await this.challengeRepository.sendChallenge(
      challengerId,
      challengedId,
      message
    );

    logger.debug('SendChallenge', 'Challenge sent successfully');

    return challenge;
  }
}
